<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Заполните контакты</h3>
      <div class="step__addressline">
        <TextInput class="step__addressline-main" :required="true" :alignRight="true" :forceError="(form.applicant.address.address && !addressIsCorrect) ? 'Укажите полный адрес' : ''" :blurcondition="houseIsFilled" @setError="errors.address = $event" :options="dadataVariants" v-model="form.applicant.address.address" text="Текущий ваш адрес проживания" name="applicant-address-address" />
        <TextInput v-show="!form.applicant.address.noflat" class="step__addressline-flat" :required="true" :alignRight="true" v-model="form.applicant.address.flat" :forceError="(form.applicant.address.address && !addressIsCorrect) ? 'Укажите полный адрес' : ''" text="Кв." name="applicant-address-flat" />
      </div>
      <CheckBox name="applicant-address-noflat" v-model="form.applicant.address.noflat">Частный дом</CheckBox>
      <NumberInput :required="true" mask="+7 (###) ###-##-##" @setError="errors.tel = $event" :filled="(v) => v.length == 18" v-model="form.applicant.tel" text="Номер мобильного телефона" name="applicant-tel" />
      <EmailInput :required="true" @setError="errors.address = $event" v-model="form.applicant.email" text="E-mail" name="applicant-email" />
      <SelInput :required="true" text="Заявитель действует от:" name="applicant-onbehalf" :options="onbehalfOptions" v-model="form.applicant.onbehalf" />
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmailInput from '@/components/inputs/EmailInput.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import Btn from '../Btn.vue';
import SelInput from '../inputs/SelInput.vue';
import NumberInput from '../inputs/NumberInput.vue';
import dadataSuggest from '@/mixins/dadataSuggest.js'
import CheckBox from '../inputs/CheckBox.vue';
export default {
  components: { TextInput, Btn, SelInput, NumberInput, EmailInput, CheckBox },
  mixins: [dadataSuggest],
  data: () => ({
    errors: {},
    onbehalfOptions: ['', 'Собственного имени и в своих интересах', 'От имени Выгодоприобретателя'],
    dadataVariants: [],
    timer: undefined
  }),
  props: {
    active: { type: Boolean }
  },
  computed: {
    ...mapState(['form', 'DaDataToken', 'DaDataUrl']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      let required = ['tel', 'email', 'onbehalf']
      for (let key of required)
        if (!this.form.applicant[key])
          return false
      required = ['address']
      if (!this.form.applicant.address.noflat)
        required.push('flat')
      for (let key of required)
        if (!this.form.applicant.address[key])
          return false
      if (!this.addressIsCorrect)
        return false
      return true
    },
    houseIsFilled(){
      if (!this.dadataVariants.includes(this.form.applicant.address.address))
        return false
      else {
        let option = this.fullDadataSuggest.find(el => el.value == this.form.applicant.address.address)
        if (!option || !option.data.house || !option.data.house_kladr_id)
          return false
        return true
      }
    },
    addressIsCorrect() {
      if (!this.houseIsFilled)
        return false
      if (!this.form.applicant.address.noflat && !this.form.applicant.address.flat)
        return false
      return true
    }
  },
  watch: {
    'form.applicant.address.address': {
      handler: async function (val) {
        if (!val)
          return this.dadataVariants = []
        clearTimeout(this.timer)
        this.timer = setTimeout(
          async () => {
            this.dadataVariants = await this.dadataSuggest(val, {
              settings: {
                query: val,
                count: 5,
                "locations": [{ "country": "Россия" }],
                "from_bound": { "value": "city" },
                "to_bound": { "value": "house" }
              }
            })
          }
          , 200)
      },
      immediate: true
    },
    'form.applicant.address.noflat': function (v) {
      if (!v)
        this.form.applicant.address.flat = ''
    }
  }
}
</script>

<style lang="sass">

</style>